module.exports = __webpack_public_path__ + "img/partner12.cba2a63f.png";